import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/permissions';

export default function usePermission(perm) {
  const { permissions = [] } = useSelector(({ profile }) => profile.data || {});
  return hasPermission(permissions, perm);
}